import React from 'react';
import styled from 'styled-components';

export default styled.li`
  display: inline-block;
  margin-left: 3px;
  letter-spacing: 0.04em;
`;
